/**
 * Core Theme JavaScript
 * Handles FAQ accordion toggles, product gallery image switcher, checkout/cart submissions, and collection filters.
 */

document.addEventListener('DOMContentLoaded', () => {
  // 1. FAQ Accordions
  const faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(item => {
    const question = item.querySelector('.faq-question');
    if (!question) return;

    question.addEventListener('click', () => {
      const isOpen = item.classList.contains('is-open');
      const container = item.closest('.faq-container');
      if (container) {
        container.querySelectorAll('.faq-item').forEach(other => other.classList.remove('is-open'));
      }
      if (!isOpen) {
        item.classList.add('is-open');
      }
    });
  });

  // 2. Product Page Image Gallery (Multi-Image Switcher)
  const thumbBtns = document.querySelectorAll('.product-thumb-item');
  const mainImg = document.getElementById('ProductMainImage');
  if (thumbBtns.length > 0 && mainImg) {
    thumbBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        thumbBtns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        const newSrc = btn.dataset.thumbnailSrc;
        if (newSrc) {
          mainImg.style.opacity = '0.3';
          mainImg.src = newSrc;
          mainImg.onload = () => { mainImg.style.opacity = '1'; };
        }
      });
    });
  }

  // 3. Product Page Purchase Form (Instant Checkout vs Add to Cart)
  const productForm = document.querySelector('.product-digital-form');
  if (productForm) {
    let lastSubmitter = null;
    productForm.querySelectorAll('button[type="submit"]').forEach(btn => {
      btn.addEventListener('click', () => { lastSubmitter = btn.getAttribute('name'); });
    });

    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const isDirectCheckout = (lastSubmitter === 'checkout');
      const submitBtn = productForm.querySelector(`button[name="${lastSubmitter || 'checkout'}"]`);
      const originalText = submitBtn ? submitBtn.innerHTML : '';

      if (submitBtn) {
        submitBtn.setAttribute('disabled', 'true');
        submitBtn.innerHTML = `<span>${isDirectCheckout ? 'Preparing Instant Download...' : 'Adding...'}</span>`;
      }

      const formData = new FormData(productForm);

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        });

        if (res.ok) {
          if (isDirectCheckout) {
            window.location.href = '/checkout';
          } else {
            showThemeToast('✓ Instant Access Added to Cart!');
            updateCartBadge();
            if (submitBtn) {
              submitBtn.removeAttribute('disabled');
              submitBtn.innerHTML = originalText;
            }
          }
        } else {
          // If AJAX endpoint fails, submit normally
          productForm.submit();
        }
      } catch (err) {
        productForm.submit();
      }
    });
  }

  // 4. Quick-Add AJAX Form Handler (Collection Cards)
  const quickAddForms = document.querySelectorAll('[data-quick-add-form]');
  quickAddForms.forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const submitBtn = form.querySelector('button[type="submit"]');
      const originalText = submitBtn ? submitBtn.innerHTML : '';

      if (submitBtn) {
        submitBtn.setAttribute('disabled', 'true');
        submitBtn.innerHTML = '<span>Adding...</span>';
      }

      const formData = new FormData(form);

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        });

        if (res.ok) {
          showThemeToast('✓ Instant Access Added to Cart!');
          updateCartBadge();
        } else {
          form.submit();
        }
      } catch (err) {
        form.submit();
      } finally {
        if (submitBtn) {
          submitBtn.removeAttribute('disabled');
          submitBtn.innerHTML = originalText;
        }
      }
    });
  });

  // 5. Collection Page Category Filter Tabs
  const colFilterBtns = document.querySelectorAll('[data-collection-filter]');
  const colCards = document.querySelectorAll('.collection-product-grid .digital-product-card');
  if (colFilterBtns.length > 0 && colCards.length > 0) {
    colFilterBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const filter = btn.dataset.collectionFilter;
        colFilterBtns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        colCards.forEach(card => {
          if (filter === 'all' || card.dataset.category === filter || card.textContent.toLowerCase().includes(filter.toLowerCase())) {
            card.style.display = 'flex';
          } else {
            card.style.display = 'none';
          }
        });
      });
    });
  }

  // Toast Helper
  function showThemeToast(msg) {
    let toast = document.querySelector('.toast-notification');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'toast-notification';
      document.body.appendChild(toast);
    }
    toast.innerHTML = `
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#10B981" stroke-width="2.5">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
      <span>${msg}</span>
    `;
    toast.classList.add('is-visible');
    setTimeout(() => toast.classList.remove('is-visible'), 3200);
  }

  // 6. Smooth Auto-Scroll & 404 Rescue Handler
  const currentPath = window.location.pathname.toLowerCase();
  const is404 = document.querySelector('.error-404-section') !== null;

  if (is404) {
    if (currentPath.includes('build-a-bundle')) {
      const bundleTarget = document.getElementById('build-a-bundle');
      if (bundleTarget) {
        setTimeout(() => {
          bundleTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 150);
      }
    } else if (currentPath.includes('bundle-landing') || currentPath.includes('master-bundle')) {
      const masterTarget = document.getElementById('master-bundle');
      if (masterTarget) {
        setTimeout(() => {
          masterTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 150);
      }
    }
  }

  // 7. Sticky Header Scroll Watcher
  const siteHeader = document.querySelector('.site-header');
  const shopifyHeader = document.getElementById('shopify-section-header');
  if (siteHeader || shopifyHeader) {
    window.addEventListener('scroll', () => {
      const isScrolled = window.scrollY > 20;
      if (siteHeader) siteHeader.classList.toggle('is-scrolled', isScrolled);
      if (shopifyHeader) shopifyHeader.classList.toggle('is-scrolled', isScrolled);
    }, { passive: true });
  }

  // Cart Count Badge Updater
  async function updateCartBadge() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const badge = document.querySelector('.cart-count-badge');
      if (badge) {
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
      }
    } catch (e) {}
  }
});
